module.exports = __webpack_public_path__ + "ml.svg?02a95bc10fc1791b510be1ecbf972359";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/ml.svg
// module id = 1244
// module chunks = 0